import {
  SET_VIOLATION_LOADING,
  LOAD_VIOLATION_DATA,
  APPEND_VIOLATION_NODES,
  RESET_VIOLATION_NODES,
  SET_VIOLATION_REMEDIATIONS,
} from '../../config/actions';

const initialState = {
  loading: false,
  metadata: {},
  items: [],
  nextCursor: null,
  hasNextPage: false,
};

export default function violationReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_VIOLATION_NODES:
      return {
        ...state,
        items: [],
        nextCursor: null,
        hasNextPage: false,
      };
    case SET_VIOLATION_LOADING:
      return { ...state, loading: action.payload };
    case LOAD_VIOLATION_DATA:
      return {
        ...state,
        metadata: {
          sessionId: action.payload.latestSessionId,
          issueLabel: action.payload.help,
          whyItMatters: action.payload.whyItMatters,
          howToFix: action.payload.howToFix,
          relevantGuidelines: action.payload.relevantGuidelines,
          impact: action.payload.impact,
          totalNodes: action.payload.totalNodes,
          diff: action.payload.diff,
          ruleId: action.payload.ruleId,
          wcagSections: (
            (action.payload.wcagSections || []).map((wcag) => [wcag.section]) ||
            []
          ).join(', '),
        },
        items: action.payload.items,
        nextCursor: action.payload.nextCursor,
        hasNextPage: action.payload.hasNextPage,
      };
    case APPEND_VIOLATION_NODES:
      return {
        ...state,
        items: [...state.items, ...action.payload.items],
        nextCursor: action.payload.nextCursor,
        hasNextPage: action.payload.hasNextPage,
      };

    case SET_VIOLATION_REMEDIATIONS:
      const remediationArray = action.payload || [];

      const remediationMap = {};

      remediationArray.forEach((r) => {
        remediationMap[r.itemId] = r;
      });

      return {
        ...state,
        items: state.items.map((item) => {
          const remediation = remediationMap[item._id];

          if (!remediation) return item;

          return {
            ...item,
            remediation: remediation.remediation,
            nodeCount: remediation.nodeCount,
          };
        }),
      };
    default:
      return state;
  }
}
